import { useEffect } from "react";
import { useUiStore } from "@/lib/store";

export function ToastContainer() {
  const notifications = useUiStore((s) => s.notifications);
  const removeNotification = useUiStore((s) => s.removeNotification);

  return (
    <div className="fixed bottom-4 right-4 space-y-2 z-50">
      {notifications.map((notif) => (
        <Toast
          key={notif.id}
          notification={notif}
          onClose={() => removeNotification(notif.id)}
        />
      ))}
    </div>
  );
}

interface ToastProps {
  notification: {
    id: string;
    type: "success" | "error" | "info" | "warning";
    message: string;
    duration?: number;
  };
  onClose: () => void;
}

function Toast({ notification, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, notification.duration ?? 4000);
    return () => clearTimeout(timer);
  }, [notification.duration, onClose]);

  const bgColor = {
    success: "bg-emerald-400/80 text-deep",
    error: "bg-red-400/80 text-white",
    info: "bg-accent/80 text-deep",
    warning: "bg-warm/80 text-deep",
  }[notification.type];

  return (
    <div
      className={`${bgColor} px-4 py-3 rounded-xl shadow-lg border border-white/25 backdrop-blur-sm flex items-center justify-between`}
    >
      <span>{notification.message}</span>
      <button onClick={onClose} className="ml-4 font-bold hover:opacity-75">
        x
      </button>
    </div>
  );
}
